// BHP-1132: the two read-models the create form needs — the choosable server
// types (priced for the active customer) and the customer's Hetzner projects.
// Both are customer-scoped by the backend (BHP-1130), so they return exactly
// what the active customer may pick from.
import { type UseQueryResult } from '@tanstack/react-query';
import { useCollection } from '../../../shared/api/useHydra';
import type { HydraCollection } from '../../../shared/api/hydra';
import type { HetznerProject, ServerTypeOption } from '../domain/vpsCreate';

/**
 * BHP-1146/1147: the choosable types for one location. The backend enriches
 * each option with `available` only when a location is given, so the query stays
 * disabled until the customer has picked one — the picker asks a location's
 * availability exactly once, then filters by category (BHP-1151) and
 * architecture (BHP-1154) client-side without another call.
 */
export function useServerTypes(
  location: string
): UseQueryResult<HydraCollection<ServerTypeOption>> {
  return useCollection<ServerTypeOption>('server-types', {
    params: { location },
    enabled: location !== ''
  });
}

export function useHetznerProjects(): UseQueryResult<
  HydraCollection<HetznerProject>
> {
  return useCollection<HetznerProject>('hetzner-accounts');
}
